import { createStyleUtils } from '@wix/style-utils'
export const SELECTOR_SEPARATOR = '___selector___'

export { createStyleUtils }
